import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { startCheck, pollCheck } from '../api';

type Phase = 'idle' | 'starting' | 'running' | 'error';

export default function CheckPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const [url, setUrl] = useState(params.get('url') ?? '');
  const urlId = params.get('urlId') ?? undefined;
  const [phase, setPhase] = useState<Phase>('idle');
  const [error, setError] = useState<string | null>(null);

  // クエリにurlが渡ってきたら自動で入力欄に反映
  useEffect(() => {
    const q = params.get('url');
    if (q) setUrl(q);
  }, [params]);

  async function run(e: React.FormEvent) {
    e.preventDefault();
    if (!url.trim()) return;
    setPhase('starting');
    setError(null);
    try {
      const job = await startCheck({ url: url.trim(), urlId });
      setPhase('running');
      const done = await pollCheck(job.checkId);
      if (done.status === 'error') {
        setPhase('error');
        setError(done.error ?? 'チェックに失敗しました。');
        return;
      }
      navigate(`/admin/check/${job.checkId}`);
    } catch (e) {
      setPhase('error');
      setError(e instanceof Error ? e.message : String(e));
    }
  }

  const busy = phase === 'starting' || phase === 'running';

  return (
    <div className="page page--narrow">
      <h1>チェック実行</h1>
      <p className="muted">
        URLを入力して実行すると、テクニカル・Core Web Vitals・構造化データ・コンテンツ品質を
        総合評価します。実行には20〜60秒程度かかります。
      </p>

      <form className="card check-form" onSubmit={run}>
        <label className="check-form__label">対象URL</label>
        <input
          className="check-form__input"
          placeholder="https://example.com/page"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          disabled={busy}
        />
        {urlId && <p className="muted small">登録URLとして履歴に記録されます。</p>}
        <button className="btn btn--primary btn--lg" disabled={busy || !url.trim()}>
          {phase === 'starting'
            ? '開始中…'
            : phase === 'running'
              ? 'チェック中…'
              : 'チェック開始'}
        </button>
      </form>

      {busy && (
        <div className="card check-progress">
          <div className="spinner" />
          <div>
            <strong>解析中です…</strong>
            <p className="muted small">
              PageSpeed Insights の計測に時間がかかります。このままお待ちください。
            </p>
          </div>
        </div>
      )}

      {error && <div className="alert alert--error">{error}</div>}
    </div>
  );
}
